<template>
  <img v-if="imgUrl()" :src="imgUrl()" :alt="room.imageAlt || ''" class="img-fluid" />
</template>

<script lang="ts">
import { Room } from '@/generated/openapi';
import { urlService } from '@/services/urlService';
import { defineComponent, PropType } from 'vue'

export default defineComponent({
  name: 'RoomImage',
  props: {
    room: {
      type: Object as PropType<Room>,
      required: true
    }
  },
  methods: {
    imgUrl() {
      return urlService.getImageUrl(this.room)
    }
  }
});
</script>
